"use strict";
var app = require("angular").module("dashboard");

app.controller("dashboardTasksCtrl", [
  "$state",
  "departments",
  "$stateParams",
  "myDepartments",
  "$scope",
  "tasks","toast","$translate","uiCalendarConfig",
  require("./dashboardTasksCtrl"),
]);
app.directive("tasks", [require("./dashboardTasksDirective")]);
app.config(["$stateProvider", require("./dashboardTasksConfig")]);
